// extracted by mini-css-extract-plugin
export default {"social":"ShareButtons_social__WBI0-","shareButton":"ShareButtons_shareButton__S7zNK"};